import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { NotFound, FiveHundred } from '@surfline/quiver-react';
import { setAdBlock } from '../../actions/adblock';
import { getStatusCode } from '../../selectors/status';
import { getPremiumStatus } from '../../selectors/user';

import DetectAdBlock from '../../components/DetectAdBlock';

class KBYGPageContainer extends Component {
  getClassName = () => classNames({
    'sl-kbyg-page-container': true,
    'sl-kbyg-page-container--is-premium': this.props.isPremium,
  });

  pageContent = () => {
    if (this.props.status === 404) {
      return <NotFound />;
    } else if (this.props.status === 500) {
      return <FiveHundred />;
    }
    return this.props.children;
  }

  render() {
    const {
      doSetAdBlock,
    } = this.props;

    return (
      <div>
        <DetectAdBlock setAdBlock={doSetAdBlock} />
        <div className={this.getClassName()}>
          {this.pageContent()}
        </div>
      </div>
    );
  }
}

KBYGPageContainer.propTypes = {
  children: PropTypes.node,
  status: PropTypes.number.isRequired,
  isPremium: PropTypes.bool.isRequired,
  doSetAdBlock: PropTypes.func.isRequired,
};

KBYGPageContainer.defaultProps = {
  children: null,
  userDetails: null,
  userSettings: null,
  userEntitlements: [],
  userFavorites: [],
};


export default connect(
  state => ({
    status: getStatusCode(state),
    isPremium: getPremiumStatus(state),
  }),
  dispatch => ({
    doSetAdBlock: detected => dispatch(setAdBlock(detected)),
  }),
)(KBYGPageContainer);



// WEBPACK FOOTER //
// ./src/containers/routes/KBYGPageContainer.js